import type { MentionRenderers, TextareaProps } from "@msuite/ui/libs/tiptap";
import React from "react";
import {
	ProjectCardMention,
	ProjectCardMentionInline,
	UserCard,
	UserCardMentionInline,
} from "@/components/cards";
import { useMembers } from "./use-members";
import { useProjects } from "./use-projects";

export function useMentionOptions(): TextareaProps {
	/** Hooks */
	const { members } = useMembers();
	const { projects } = useProjects();

	/** Renderers */
	const mentionRenderers: MentionRenderers = {
		member: (userId, type) => (
			<React.Fragment>
				{type === "list" && (
					<UserCard
						userId={userId}
						variant="plain"
					/>
				)}
				{type === "inline" && <UserCardMentionInline userId={userId} />}
			</React.Fragment>
		),
		project: (projectId, type) => (
			<React.Fragment>
				{type === "list" && <ProjectCardMention projectId={projectId} />}
				{type === "inline" && <ProjectCardMentionInline projectId={projectId} />}
			</React.Fragment>
		),
	};

	return { members, projects, mentionRenderers };
}
